/** @format */

import { Box } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";

export function Container({ props, horizontal = false, children }) {
  const { validoapartir, clube, inCaroussel, idtiporecomendacao } = props;
  const {
    personalizacao: { card },
  } = usePersonalizacao();

  const getCorBgDestaque = () => {
    if (idtiporecomendacao === "1") {
      return card?.descontoexclusivo?.colordestaqueseloclube
        ? card?.descontoexclusivo?.colordestaqueseloclube
        : card?.colordestaqueseloclube;
    }
    if (idtiporecomendacao === "2") {
      return card?.tabloide?.colordestaqueseloclube
        ? card?.tabloide?.colordestaqueseloclube
        : card.colordestaqueseloclube;
    }
    if (idtiporecomendacao === "3") {
      return card?.cashback?.colordestaqueseloclube
        ? card?.cashback?.colordestaqueseloclube
        : card?.colordestaqueseloclube;
    }
  };

  const stylesVertical = {
    maxW: "204px",
    display: "flex",
    flexDir: "column",
    justifyContent: "space-between",
    background: "white",
    borderRadius: "md",
    margin: "0.25rem",
    border: clube ? "1px solid" : "none",
    borderColor: validoapartir && clube ? "#70747D" : getCorBgDestaque,
    h: inCaroussel ? "97.5%" : "100%",
    boxShadow: "3px 5px 6px -1px rgba(0,0,0,0.20)",
  };

  const stylesHorizontal = {
    width: "100%",
    display: "flex",
    flexDir: "column",
    background: "white",
    borderRadius: "md",
    boxShadow: "5px 5px 6px -1px rgba(0,0,0,0.20)",
    border: clube ? "1px solid" : "none",
    borderColor: validoapartir && clube ? "#70747D" : getCorBgDestaque,
  };

  const validaStyles = !horizontal ? stylesVertical : stylesHorizontal;

  return <Box {...validaStyles}>{children}</Box>;
}
